import React, { useState, useEffect, useRef, use } from "react";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  IconButton,
  useTheme,
  useMediaQuery,
  Tooltip
} from "@mui/material";
import {
  AccessTime,
  Favorite,
  DeliveryDining,
  Shield,
  Download,
  Warning,
  WhatsApp
} from "@mui/icons-material";
import { useRestaurant } from "../../contexts/RestaurantContext";
import { useNotification } from "../../contexts/NotificationContext";
import { useCustomTheme } from "../../contexts/ThemeContext";
import menuCardService from "../../services/menuCardService";
import { useParams, useSearchParams } from 'react-router-dom';
import OutletSelectionModal from "../../components/user/OutletSelectionModal";
import Footer from "../../components/user/Footer";
import Footer2 from "../../components/user/Footer2";
import HeroSlider from "../../components/user/HeroSlider";
import ViewDetailsModal from "../../components/user/ViewDetailsModal";
import { useNavigate } from "react-router-dom";
import {
  MenuItemSkeleton,
  CategorySkeleton,
  HeroSkeleton,
  SearchBarSkeleton,
  FilterSectionSkeleton,
  PageHeaderSkeleton,
} from "../../components/common/SkeletonLoader";
import { useDebounce } from "../../hooks/usePerformanceOptimization";
import TestimonialSlider from "./TestimonialSlider";
import service_1 from "../../static/services/Delivery.png";
import service_2 from "../../static/services/Takeaway.png";
import service_3 from "../../static/services/Catering.png";
import service_4 from "../../static/services/Reservations.png";
import { HomePageColor } from "../../components/Themes/themeColorConfig";
import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import delivery_img from '../../static/choose/deliveryimage.png'
import quick_prep from '../../static/choose/QuickPrep.png'
import loved_by_foodies from '../../static/choose/LovedbyFoodies.png'
import Hygenic_safe from '../../static/choose/HygienicSafe.png'
import about_img from '../../static/about/Aboutusimage.png'
import s_1 from '../../static/signature_dishes/1.png'
import s_2 from '../../static/signature_dishes/2.png'
import s_3 from '../../static/signature_dishes/3.png'
import s_4 from '../../static/signature_dishes/4.png'
import s_5 from '../../static/signature_dishes/5.png'
import s_6 from '../../static/signature_dishes/6.png'
import s_7 from '../../static/signature_dishes/7.png'
import s_8 from '../../static/signature_dishes/8.png'
import s_9 from '../../static/signature_dishes/9.png'
import s_10 from '../../static/signature_dishes/10.png'
import s_11 from '../../static/signature_dishes/11.png'
import s_12 from '../../static/signature_dishes/12.png'
import s_13 from '../../static/signature_dishes/13.png'
import s_14 from '../../static/signature_dishes/14.png'
import menu from '../../static/menu.png'
import menuPDF from '../../static/rangooli_menu.pdf'
import CommonModal from "../../components/common/CommonModal";
import { getAuth } from "../../services/onemapService";
import { clear_fcm_token } from "../../services/notificationService";
import publicApi from "../../services/publicApi";
import FeedbackModal from "../../components/common/FeedbackModal"
import { feedbackFormStatus, getSpecificFeedback } from "../../services/feedBackService"
import { v4 as uuidv4 } from 'uuid';


const uuid = uuidv4();

// import HeroSection from "./HeroSection";
const dishImages = [s_1, s_2, s_3, s_4, s_5, s_6, s_7, s_8, s_9, s_10, s_11, s_12, s_13, s_14];

const ScrollAnimation = ({
  children,
  animation = "fadeUp",
  delay = 0,
  threshold = 0.1,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // async function getToken(){
    //   try{
    //     const response = await getAuth()
    //     console.log(response)
    //     console.log(response["data"])
    //     localStorage.setItem("oneMapToken",response.data.token)
    //   } 
    //   catch(error){
    //     console.error("Error Happened ", error)
    //   }
    // }
    // getToken()
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [threshold]);





  const getAnimationStyle = () => {
    const baseStyle = {
      transition: "all 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
      transitionDelay: `${delay}ms`,
    };

    if (!isVisible) {
      switch (animation) {
        case "fadeUp":
          return {
            ...baseStyle,
            opacity: 0,
            transform: "translateY(50px)",
          };
        case "fadeLeft":
          return {
            ...baseStyle,
            opacity: 0,
            transform: "translateX(-50px)",
          };
        case "fadeRight":
          return {
            ...baseStyle,
            opacity: 0,
            transform: "translateX(50px)",
          };
        case "scale":
          return {
            ...baseStyle,
            opacity: 0,
            transform: "scale(0.8)",
          };
        default:
          return {
            ...baseStyle,
            opacity: 0,
            transform: "translateY(50px)",
          };
      }
    }

    return {
      ...baseStyle,
      opacity: 1,
      transform: "translateY(0) translateX(0) scale(1)",
    };
  };

  return (
    <div ref={ref} style={getAnimationStyle()}>
      {children}
    </div>
  );
};

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

// Staggered Animation Container
const StaggeredContainer = ({
  children,
  staggerDelay = 100,
  animation = "fadeUp",
}) => {
  return React.Children.map(children, (child, index) => (
    <ScrollAnimation animation={animation} delay={index * staggerDelay}>
      {child}
    </ScrollAnimation>
  ));
};

const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1, ease: "easeOut" } },
};

const HomePage = () => {
  const [viewMode, setViewMode] = useState("grid");
  const [showFilters, setShowFilters] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [viewDetailsOpen, setViewDetailsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [favorites, setFavorites] = useState(new Set());
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [selectedServiceType, setSelectedServiceType] = useState(null);
  const [showServiceSelection, setShowServiceSelection] = useState(false);
  const [downloadingMenuPDF, setDownloadingMenuPDF] = useState(false);
  const [signatureDishes, setSignatureDishes] = useState([]);
  const [actualServiceType, setActualServiceType] = useState("");
  const [adminNavigationModalOpen,setAdminNavigationModalOpen] = useState(false)
  const {
    restaurant,
    categories,
    menuItems,
    filters,
    setFilters,
    getFilteredMenuItems,
    getCartItemCount,
    getCartTotal,
    loading: restaurantLoading,
    outlets,
    selectedOutlet,
    selectOutlet,
    isDeliveryAvailable,
    isTakeawayAvailable,
    isDineInAvailable,
    getAvailableServiceTypes,
    loadOutletsByService,
    outletsLoading,
    outletsLoadingAttempted,
    cart,
    addToCart,
    sliderImages,
    showOutletSelectionModal,
    isFirstVisit,
    handleOutletSelection,
    showOutletSelection,
    closeOutletSelection,
  } = useRestaurant();

  const { guestId, orderType, orderId } = useParams();
  const [searchParams] = useSearchParams();

  const [modalOpen, setModalOpen] = useState(false)
  const [serviceModalText, setServiceModalText] = useState("")
  const [socialLinks, setSocialLinks] = useState({})
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false)
  const [feedbackData, setFeedBackData] = useState({})
  const [feedbackDetailsData, setFeedbackDetailsData] = useState({})
  const [feedbackSessionID, setFeedbackSessionID] = useState("")
  const [feedbackType, setFeedbackType] = useState("DELIVERY")
  const [feedbackAllData, setFeedbackAllData] = useState({})


  const [serviceImages, setServiceImages] = useState([
    {
      id: 1,
      img: service_1,
      btn_text: "Order Now",
      navigation: "/delivery",
      title: "Delivery",
      description: "Get your favorite dishes delivered right to your doorstep",
    },
    {
      id: 2,
      img: service_2,
      btn_text: "Order Now",
      navigation: "/delivery",
      title: "Takeaway",
      description: "Quick pickup service for your convenience",
    },
    {
      id: 3,
      img: service_3,
      btn_text: "Book Now",
      navigation: "/catering",
      title: "Catering",
      description: "Perfect menus for your special events and celebrations",
    },
    {
      id: 4,
      img: service_4,
      btn_text: "Book Table",
      navigation: "/table-reservations",
      title: "Table Reservations",
      description: "Book your perfect table for a memorable dining experience",
    },
  ]);

  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  const theme = useTheme();
  const { isDarkMode } = useCustomTheme();
  const { showError, showSuccess } = useNotification();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const pageColor = new HomePageColor();




  const features = [
    {
      title: "Fast Delivery",
      desc: "Your online orders are packed and shipped quickly, arriving at your door faster than standard shipping methods.",
      image: delivery_img,
      icon: (
        <DeliveryDining
          sx={{
            fontSize: {
              xs: "28px !important",
              sm: "32px !important",
              md: "36px !important",
            },
            color: "#FFD700 !important",
          }}
        />
      ),
    },
    {
      title: "Quick Prep",
      desc: "Spend less time preparing and more time enjoying. Our quick preparation gets you from start to finish faster.",
      image:
        "https://www.fooddocs.com/hs-fs/hubfs/restaurant%20food%20preparation%20methods.jpg",
      icon: (
        <AccessTime
          sx={{
            fontSize: {
              xs: "28px !important",
              sm: "32px !important",
              md: "36px !important",
            },
            color: "#FFD700 !important",
          }}
        />
      ),
    },
    {
      title: "Loved by Foodies",
      desc: "Discover why food lovers and flavor seekers recommend us. This is the good stuff they can't stop talking about.",
      image:
        "https://media.istockphoto.com/id/2000117676/photo/here-try-some-tacos-are-super-tasty.jpg?s=612x612&w=0&k=20&c=cPSqg040qMkg5uYiKUhqg7QJkwwNR9_ZYbnzlZ2-rF8=",
      icon: (
        <Favorite
          sx={{
            fontSize: {
              xs: "28px !important",
              sm: "32px !important",
              md: "36px !important",
            },
            color: "#FFD700 !important",
          }}
        />
      ),
    },
    {
      title: "Hygienic & Safe",
      desc: "All items are made, handled, and packaged using strict cleanliness standards to ensure your complete safety.",
      image: Hygenic_safe,
      icon: (
        <Shield
          sx={{
            fontSize: {
              xs: "28px !important",
              sm: "32px !important",
              md: "36px !important",
            },
            color: "#FFD700 !important",
          }}
        />
      ),
    },
  ];


  const filteredItems = getFilteredMenuItems();
  const cartItemCount = getCartItemCount();
  const cartTotal = getCartTotal();

  const clear_fcm = async () => {
    await clear_fcm_token()
    localStorage.removeItem('tk_id');
  }
  const fetchSpecificFeedback = async (payload) => {
    try {
      const response = await getSpecificFeedback(payload);
      // console.log("Response => ", response);
      return response;
    } catch (error) {
      console.error(error);
      return null; // Return null on error
    }
  };

  useEffect(() => {
    const fetchFeedbackData = async () => {
      // Get guestId from URL params
      const finalGuestId = guestId;
      const finalOrderId = orderId;

      // console.log('Guest ID:', finalGuestId);
      // console.log('Order ID:', finalOrderId);
      // console.log('Order Type:', orderType);

      // Only proceed if we have all required data
      if (finalGuestId && finalOrderId && orderType) {
        let payload = {
          "guest_id": finalGuestId,
          "order_id": finalOrderId,
          "order_type": orderType
        };

        const feedbackMailData = await fetchSpecificFeedback(payload);
        // console.log('Feedback Data:', feedbackMailData);

        if (feedbackMailData?.order?.status) {
          setFeedBackData(feedbackMailData);
          setFeedbackModalOpen(true);
          setFeedbackDetailsData(feedbackMailData?.order?.details);
          setFeedbackSessionID(feedbackMailData?.order?.user_session_id)
          setFeedbackType(feedbackMailData?.order?.type);
          setFeedbackAllData(feedbackMailData?.order);
        }
        else if (feedbackMailData?.reservation?.status) {
          setFeedBackData(feedbackMailData);
          setFeedbackModalOpen(true);
          setFeedbackDetailsData(feedbackMailData?.reservation?.details);
          setFeedbackSessionID(feedbackMailData?.reservation?.user_session_id)
          setFeedbackType("RESERVATION");
          setFeedbackAllData(feedbackMailData.order);
        }
        else if (feedbackMailData?.catering?.status) {
          setFeedBackData(feedbackMailData);
          setFeedbackModalOpen(true);
          setFeedbackDetailsData(feedbackMailData?.catering?.details);
          setFeedbackSessionID(feedbackMailData?.catering?.user_session_id)
          setFeedbackType("CATERING");
          setFeedbackAllData(feedbackMailData?.order);
        }
      } else {
        // console.log('Missing required data for feedback check');
      }
    };

    fetchFeedbackData();
  }, [guestId, orderId, orderType]); // Added orderType as dependency


  useEffect(() => {
    if (filteredItems.length > 0) {
      const sigDishes = filteredItems.filter((item) => item.signature_dish);
      setSignatureDishes(sigDishes);
    } else {
      setSignatureDishes([]);
    }

    fetchSocialLinks()
  }, []);

  const getDeviceUUID = () => {
    let uuid = localStorage.getItem("device_uuid");

    if (!uuid) {
      uuid = crypto.randomUUID(); // Generates UUID v4
      localStorage.setItem("device_uuid", uuid);
    }

    return uuid;
  };



  useEffect(() => {
    const feedbackFormStatusCheck = async (guestId) => {
      const payload = {
        guest_id: guestId,
      };

      try {
        const response = await feedbackFormStatus(payload);
        // console.log("Feedback Response =>", response);
        if (response.order.status) {
          setFeedBackData(response)
          setFeedbackModalOpen(true);
          setFeedbackDetailsData(response.order.details)
          setFeedbackSessionID(response.order.user_session_id)
          setFeedbackType(response.order.type)
          setFeedbackAllData(response.order)
        }
        else if (response.reservation.status) {
          setFeedBackData(response)
          setFeedbackModalOpen(true);
          setFeedbackDetailsData(response.reservation.details)
          setFeedbackSessionID(response.reservation.user_session_id)
          setFeedbackType("RESERVATION")
          setFeedbackAllData(response.reservation)
        }
        else if (response.catering.status) {
          setFeedBackData(response)
          setFeedbackModalOpen(true);
          setFeedbackDetailsData(response.reservation.details)
          setFeedbackSessionID(response.catering.user_session_id)
          setFeedbackType("CATERING")
          setFeedbackAllData(response.catering)
        }

      } catch (error) {
        console.error(error);
      }
    };

    const initialize = async () => {
      let deviceUUID = localStorage.getItem("device_uuid");

      if (!deviceUUID) {
        deviceUUID = getDeviceUUID(); // Make sure this returns the UUID
      }
      const isHomePage = window.location.pathname === '/';
      if (deviceUUID && isHomePage) {
        await feedbackFormStatusCheck(deviceUUID);
      }
    };


    initialize();
  }, []);


  useEffect(() => {
  if (localStorage.getItem('admin_outlet_id')) {
      // setAdminNavigationModalOpen(true)
      let data = window.confirm("Are You Sure ? You are going to logout from Admin ")
      if (!data){
        navigate("admin/dashboard/")
        return;
      }
      localStorage.removeItem("admin_outlet_id")

      
    }

  }, [])

  const handleConfirm = () => {
    setAdminNavigationModalOpen(false)
  }

  const handleCancel = () => {
    setAdminNavigationModalOpen(false);
    navigate('admin/dashboard')
  }

  const testShowModal = () => {
    // console.log("HomePage - Manually triggering outlet selection modal");
    showOutletSelection();
  };

  const handleCategoryFilter = (categoryId) => {
    setFilters((prev) => ({
      ...prev,
      category: prev.category === categoryId ? null : categoryId,
    }));
    navigate("/delivery", {
      state: {
        category_id: categoryId,
      },
    });
  };

  // console.log("Selected Outlet => ", selectedOutlet)

  const handleVegFilter = (isVeg) => {
    setFilters((prev) => ({
      ...prev,
      isVeg: prev.isVeg === isVeg ? null : isVeg,
    }));
  };

  const handlePriceRangeChange = (event, newValue) => {
    setFilters((prev) => ({
      ...prev,
      priceRange: newValue,
    }));
  };

  const handleSortChange = (event) => {
    setFilters((prev) => ({
      ...prev,
      sortBy: event.target.value,
    }));
  };

  const toggleFavorite = (itemId) => {
    setFavorites((prev) => {
      const newFavorites = new Set(prev);
      if (newFavorites.has(itemId)) {
        newFavorites.delete(itemId);
      } else {
        newFavorites.add(itemId);
      }
      return newFavorites;
    });
  };

  const handleServiceTypeSelect = (serviceType) => {
    if (serviceType === "delivery" && !isDeliveryAvailable()) {
      return;
    }
    if (serviceType === "takeaway" && !isTakeawayAvailable()) {
      return;
    }

    if (!cart || cart.length === 0) {
      showError && showError("Please add items to your cart first");
      return;
    }

    setSelectedServiceType(serviceType);
    setShowPaymentForm(true);
  };

  const handleAddToCart = (item, quantity, addons, specialInstructions) => {
    addToCart(item, quantity, addons, specialInstructions);

    if (cart.length === 0) {
      setShowServiceSelection(true);
    }
  };

  const handlePaymentSuccess = (orderData) => {
    navigate("/order-success", { state: { orderData } });
  };

  const handleDownloadMenuPDF = async () => {
    try {
      setDownloadingMenuPDF(true);

      if (!selectedOutlet) {
        showError("Please select an outlet first");
        return;
      }

      if (!menuItems || menuItems.length === 0) {
        showError("No menu items available for download");
        return;
      }

      const pdfBlob = await menuCardService.generateMenuCardPDF(
        selectedOutlet,
        menuItems,
        categories
      );

      const filename = `Menu_${selectedOutlet.name.replace(/\s+/g, "_")}_${new Date().toISOString().split("T")[0]
        }.pdf`;
      menuCardService.downloadPDF(pdfBlob, filename);

      showSuccess("Menu PDF downloaded successfully!");
    } catch (error) {
      console.error("Error downloading menu PDF:", error);
      showError(`Failed to download menu PDF: ${error.message}`);
    } finally {
      setDownloadingMenuPDF(false);
    }
  };

  const handleWhatsAppClick = () => {

    // console.log(socialLinks)
    const message = "Hello! I'd like to know more about Rangooli. Could you please assist me?";

    const whatsappUrl = `${socialLinks?.whatsapp}?text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, "_blank");
  };

  const fetchSocialLinks = async () => {
    try {
      const response = await publicApi.get('/public/social-links')
      // console.log("Social Links => ", response)
      setSocialLinks(response.data)
    }
    catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (outlets.length === 0 && !outletsLoadingAttempted) {
      loadOutletsByService(null).catch((error) => {
        loadOutletsByService("delivery").catch((error2) => { });
      });
    }



  }, [outlets.length, outletsLoadingAttempted, loadOutletsByService]);

  const getSearchResults = () => {
    if (!debouncedSearchQuery.trim()) return filteredItems;
    return filteredItems.filter(
      (item) =>
        item.name.toLowerCase().includes(debouncedSearchQuery.toLowerCase()) ||
        item.description
          .toLowerCase()
          .includes(debouncedSearchQuery.toLowerCase())
    );
  };

  const handleMenuDownload = () => {
    // Assuming your PDF file is in the public folder
    const pdfUrl = menuPDF; // Update this path to your actual PDF file

    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'Menu.pdf'; // The filename for the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const searchResults = getSearchResults();
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const container = scrollRef.current;
      const scrollAmount = 300;

      container.scrollTo({
        left:
          direction === "left"
            ? container.scrollLeft - scrollAmount
            : container.scrollLeft + scrollAmount,
        behavior: "smooth",
      });
    }
  };

  if (restaurantLoading || !restaurant?.theme_config) {
    return (
      <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <PageHeaderSkeleton />
          <HeroSkeleton />
          <SearchBarSkeleton />
          <FilterSectionSkeleton />
          <Box sx={{ mb: 4, marginTop: "0px !important" }}>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
              Categories
            </Typography>
            <CategorySkeleton count={8} />
          </Box>
          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
              Menu Items
            </Typography>
            <MenuItemSkeleton count={6} />
          </Box>
        </Container>
        <Footer />
      </Box>
    );
  }

  const themeColors = {
    accent: restaurant?.theme_config?.accent_color || "#FF6B35",
    primary: restaurant?.theme_config?.primary_color || "#D4AF37",
    secondary: restaurant?.theme_config?.secondary_color || "#8B4513",
  };

  return (
    <>
      {/* <motion.div initial="hidden" whileInView="visible" variants={fadeUp}>
        <HeroSection />
      </motion.div> */}
      <Box
        sx={{
          bgcolor: "background.default",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <FeedbackModal modalOpen={feedbackModalOpen} setModalOpen={setFeedbackModalOpen} type={feedbackType} session_id={feedbackSessionID} feedbackDetails={feedbackDetailsData} feedBackAllData={feedbackAllData} />

        <Box sx={{ flexGrow: 1 }}>
          <>
            {categories.length > 0 &&
              <Box
                sx={{
                  width: "100%",
                  py: { xs: 4, md: 6 },
                  bgcolor: "#fff",
                  overflowX: "hidden !important", // ✅ block horizontal flicker
                  overflowY: "hidden !important", // ✅ also prevent vertical scroll
                }}
              >
                <Container
                  maxWidth="xl"
                  sx={{
                    overflowY: "hidden !important",
                    overflowX: "hidden !important", // ✅ block horizontal flicker
                  }}
                >
                  <motion.div
                    initial="hidden"
                    whileInView="visible"
                    variants={fadeUp}
                  >
                    <Typography
                      textAlign="center"
                      sx={{
                        fontFamily: "playfair Display !important",
                        maxWidth: "xl",
                        margin: "0 auto",
                        mb: { xs: 0.5, md: 1 },
                        color: "#680000",
                        textTransform: "uppercase",
                        letterSpacing: 1,
                        fontSize: {
                          xs: "16px !important",
                          sm: "24px !important",
                          md: "32px !important",
                        },
                        fontWeight: 600,
                      }}
                    >
                      Explore by Category
                    </Typography>
                  </motion.div>

                  <motion.div
                    initial="hidden"
                    whileInView="visible"
                    variants={fadeUp}
                  >
                    <Typography
                      textAlign="center"
                      sx={{
                        mb: { xs: 2, md: 4 },
                        color: "#1A1A1A",
                        letterSpacing: 1,
                        fontSize: {
                          xs: "12px !important",
                          sm: "16px !important",
                          md: "18px !important",
                        },
                        fontWeight: "400 !important",
                      }}
                    >
                      Explore our carefully crafted menu, featuring the finest
                      Indian dishes made with authentic spices and traditional
                      recipes
                    </Typography>
                  </motion.div>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      maxWidth: "1440px",
                      margin: "0 auto",
                      px: { xs: 1, sm: 2, md: 4 },
                      position: "relative",
                    }}
                  >

                    {categories.length > 5 &&
                      <motion.div
                        initial="hidden"
                        whileInView="visible"
                        variants={fadeUp}
                      >
                        <IconButton
                          onClick={() => scroll("left")}
                          sx={{
                            bgcolor: "#f5f5f5",
                            boxShadow: 2,
                            "&:hover": { bgcolor: "#e0e0e0" },
                            mr: { xs: 1, sm: 2, md: 3 },
                            flexShrink: 0,
                          }}
                        >
                          <ArrowBackIosNew fontSize="small" />
                        </IconButton>
                      </motion.div>}

                    <Box
                      ref={scrollRef}
                      sx={{
                        display: "flex",
                        overflowX: "auto !important", // ✅ horizontal scroll active
                        overflowY: "hidden !important", // ✅ disable vertical scroll
                        scrollBehavior: "smooth",
                        gap: { xs: 2, sm: 3, md: 4 },
                        px: { xs: 2, sm: 3, md: 4 },
                        "&::-webkit-scrollbar": { display: "none" },
                        py: 2,
                        flex: 1,
                      }}
                    >
                      <StaggeredContainer staggerDelay={100} animation="fadeUp">
                        {categories.map((cat) => (
                          <Card
                            key={cat.id}
                            onClick={() =>
                              cat.is_active && handleCategoryFilter(cat.id)
                            }
                            sx={{
                              flex: "0 0 auto",
                              width: { xs: 140, sm: 180, md: 200 },
                              height: { xs: 180, sm: 200, md: 220 },
                              borderRadius: "16px",
                              overflow: "hidden !important",
                              position: "relative",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                              cursor: cat.is_active ? "pointer" : "not-allowed",
                              opacity: cat.is_active ? 1 : 0.6,
                              transition:
                                "transform 0.3s ease, box-shadow 0.3s ease, border 0.3s ease",
                              "&:hover": {
                                transform: cat.is_active
                                  ? "translateY(-6px)"
                                  : "none",
                                boxShadow: cat.is_active
                                  ? "0 8px 20px rgba(0,0,0,0.15)"
                                  : "none",
                                border: cat.is_active
                                  ? "2px solid #680000"
                                  : "none",
                              },
                            }}
                          >
                            <Box
                              sx={{
                                width: "100%",
                                height: "100%",
                                backgroundImage: `url(${cat.image_url ||
                                  "https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?auto=format&fit=crop&w=800&q=60"
                                  })`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                position: "relative",
                                display: "flex",
                                alignItems: "flex-end",
                              }}
                            >
                              <Box
                                sx={{
                                  position: "absolute",
                                  bottom: 0,
                                  left: 0,
                                  right: 0,
                                  height: "50%",
                                  background:
                                    "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0))",
                                }}
                              />

                              <Typography
                                variant="subtitle1"
                                sx={{
                                  position: "absolute",
                                  bottom: 10,
                                  left: 10,
                                  right: 10,
                                  textAlign: "left",
                                  color: "white",
                                  fontWeight: 600,
                                  fontSize: {
                                    xs: "13px !important",
                                    sm: "15px !important",
                                    md: "17px !important",
                                    lg: "19px !important",
                                  },
                                  zIndex: 2,
                                  textShadow: "0 1px 3px rgba(0,0,0,0.5)",
                                }}
                              >
                                {cat.name}
                              </Typography>
                            </Box>
                          </Card>
                        ))}
                      </StaggeredContainer>
                    </Box>

                    {categories.length > 5 &&
                      <motion.div
                        initial="hidden"
                        whileInView="visible"
                        variants={fadeUp}
                      >
                        <IconButton
                          onClick={() => scroll("right")}
                          sx={{
                            bgcolor: "#680000",
                            color: "white",
                            boxShadow: 2,
                            "&:hover": { bgcolor: "#4c0000" },
                            ml: { xs: 1, sm: 2, md: 3 },
                            flexShrink: 0,
                          }}
                        >
                          <ArrowForwardIos fontSize="small" />
                        </IconButton>
                      </motion.div>
                    }
                  </Box>
                </Container>
              </Box>
            }
          </>

          <Box
            sx={{
              width: "100%",
              py: { xs: 6, md: 10 },
              background: "linear-gradient(to bottom, #fff7f2, #fbe4d8)",
              overflowX: "hidden !important",
              overflowY: "hidden !important",
            }}
          >
            <Container>
              {/* Section Title */}
              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={fadeUp}
              >
                <Typography
                  textAlign="center"
                  sx={{
                    fontFamily: "playfair Display !important",
                    maxWidth: "xl",
                    margin: "0 auto",
                    mb: { xs: 0.5, md: 1 },
                    color: "#680000",
                    textTransform: "uppercase",
                    letterSpacing: 1,
                    fontSize: {
                      xs: "16px !important",
                      sm: "24px !important",
                      md: "32px !important",
                    },
                    fontWeight: 600,
                  }}
                >
                  Why Choose Us
                </Typography>
                <Typography
                  textAlign="center"
                  sx={{
                    mb: { xs: 2, md: 4 },
                    color: "#1A1A1A",
                    letterSpacing: 1,
                    fontSize: {
                      xs: "12px !important",
                      sm: "16px !important",
                      md: "18px !important",
                    },
                    fontWeight: "400 !important",
                  }}
                >
                  Where every meal is a royal experience filled with warmth,
                  flavor, and tradition.
                </Typography>
              </motion.div>

              {/* Feature Cards */}
              <Grid
                container
                spacing={{ xs: 3, sm: 4, md: 6 }}
                justifyContent="center"
                alignItems="flex-start"
                sx={{
                  maxWidth: "1440px",
                  margin: { md: "0 auto" },
                  overflowY: "hidden !important",
                  overflowX: "hidden !important",
                }}
              >
                {features.map((f, i) => (
                  <Grid item xs={12} sm={6} md={3} key={i}>
                    <motion.div
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      variants={fadeUp}
                      transition={{ delay: i * 0.2 }}
                    >
                      <Box
                        sx={{
                          position: "relative",
                          borderRadius: "20px",
                          overflow: "hidden",
                          height: 320,
                          cursor: "pointer",
                          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                          "&:hover img": { transform: "scale(1.1)" },
                          "&:hover .overlay": { opacity: 0.3 },
                        }}
                      >
                        {/* Background Image */}
                        <Box
                          component="img"
                          src={f.image}
                          alt={f.title}
                          sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            transition: "transform 0.6s ease",
                          }}
                        />
                        {/* Overlay */}
                        <Box
                          className="overlay"
                          sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "#000",
                            opacity: 0.45,
                            transition: "opacity 0.3s ease",
                          }}
                        />
                        {/* Content */}
                        <Box
                          sx={{
                            position: "absolute",
                            bottom: 0,
                            color: "#fff",
                            textAlign: "center",
                            px: 2,
                            pb: 3,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              mb: 1.5,
                            }}
                          >
                            {f.icon}
                          </Box>
                          <Typography
                            sx={{
                              fontWeight: "700 !important",
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                              mb: 0.5,
                              fontFamily: "Playfair Display !important",
                            }}
                          >
                            {f.title}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: {
                                xs: "11px !important",
                                sm: "13px !important",
                              },
                              lineHeight: "1.4 !important",
                              fontFamily: "Inter, sans-serif !important",
                            }}
                          >
                            {f.desc}
                          </Typography>
                        </Box>
                      </Box>
                    </motion.div>
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Box>

          <Box
            sx={{
              width: "100%",
              py: { xs: 6, md: 8 },
              bgcolor: "#fff",
              overflowX: "hidden !important", // 🚫 no horizontal scroll
              overflowY: "hidden !important", // 🚫 no vertical scroll
            }}
          >
            <Container
              maxWidth="xl"
              sx={{
                overflowX: "hidden !important", // 🚫 enforce no scroll
                overflowY: "hidden !important",
              }}
            >
              <motion.div
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                style={{
                  textAlign: "center",
                  marginBottom: "2rem",
                  overflowX: "hidden",
                  overflowY: "hidden",
                }}
              >
                <motion.div variants={itemVariants}>
                  <Typography
                    textAlign="center"
                    sx={{
                      fontFamily: "playfair Display !important",
                      color: "#680000",
                      textTransform: "uppercase",
                      letterSpacing: 1,
                      fontWeight: "600 !important",
                      fontSize: {
                        xs: "16px !important",
                        sm: "24px !important",
                        md: "32px !important",
                      },
                      mb: { xs: 0.5, md: 1 },
                    }}
                  >
                    Our Services
                  </Typography>
                </motion.div>

                <motion.div variants={itemVariants}>
                  <Typography
                    textAlign="center"
                    sx={{
                      mb: { xs: 2, md: 4 },
                      color: "#1A1A1A",
                      letterSpacing: 1,
                      fontSize: {
                        xs: "12px !important",
                        sm: "16px !important",
                        md: "18px !important",
                      },
                      fontWeight: "400 !important",
                    }}
                  >
                    Discover the perfect way to enjoy our delicious food
                  </Typography>
                </motion.div>
              </motion.div>

              {/* Cards Section */}
              <motion.div
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.1 }}
                style={{ overflow: "hidden" }}
              >
                <Grid
                  container
                  spacing={{ xs: 3, sm: 4, md: 4 }}
                  justifyContent="center"
                  sx={{
                    maxWidth: "1440px",
                    margin: { md: "0 auto" },
                    overflowX: "hidden !important",
                    overflowY: "hidden !important",
                  }}
                >
                  {serviceImages.map((item, index) => (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      key={index}
                      sx={{
                        overflowX: "hidden !important",
                        overflowY: "hidden !important",
                      }}
                    >
                      <motion.div variants={itemVariants}>
                        <Card
                          sx={{
                            textAlign: "center",
                            borderRadius: "16px",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                            transition: "all 0.3s ease",
                            "&:hover": {
                              transform: "translateY(-5px)",
                              boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                            },
                            backgroundColor: "#F9F9F9",
                            overflow: "hidden !important",
                          }}
                        >
                          <CardContent
                            sx={{ p: 3, overflow: "hidden !important" }}
                          >
                            {/* Image */}
                            <Box
                              component="img"
                              src={item.img}
                              alt={item.title}
                              sx={{
                                width: "100px",
                                height: "100px",
                                mb: 2,
                                mx: "auto",
                                display: "block",
                                overflow: "hidden !important",
                              }}
                            />

                            {/* Title */}
                            <Typography
                              variant="subtitle1"
                              sx={{
                                fontWeight: "700 !important",
                                color: "#680000",
                                fontSize: {
                                  xs: "13px !important",
                                  sm: "15px !important",
                                  md: "16px !important",
                                },
                                mb: 0.5,
                                fontFamily: "Inter, sans-serif !important",
                                overflow: "hidden !important",
                              }}
                            >
                              {item.title}
                            </Typography>

                            {/* Description */}
                            <Typography
                              variant="body2"
                              sx={{
                                color: "#1A1A1A",
                                fontSize: {
                                  xs: "11px !important",
                                  sm: "13px !important",
                                  md: "14px !important",
                                },
                                minHeight: "60px",
                                mb: 3,
                                overflow: "hidden !important",
                              }}
                            >
                              {item.description}
                            </Typography>

                            {/* Button */}
                            <Button
                              variant="contained"
                              fullWidth
                              onClick={() => {
                                if (item.title === "Delivery" && selectedOutlet.is_delivery_available) {
                                  navigate(item.navigation)
                                }
                                else if (item.title === "Takeaway" && selectedOutlet.is_takeaway_available) {
                                  navigate(item.navigation)
                                }
                                else if (item.title === "Table Reservations" && selectedOutlet.is_table_reservation_available) {
                                  navigate(item.navigation)
                                }
                                else if (item.title === "Catering") {
                                  navigate(item.navigation)
                                }
                                else {
                                  setModalOpen(true)
                                  setServiceModalText(item.title)
                                }

                              }}
                              sx={{
                                backgroundColor: "#680000",
                                color: "#fff",
                                textTransform: "none",
                                fontWeight: 600,
                                py: 1,
                                borderRadius: "8px",
                                "&:hover": {
                                  backgroundColor: "#8b0000",
                                },
                                fontSize: "14px !important",
                                overflow: "hidden !important",
                              }}
                            >
                              {item.btn_text}
                            </Button>
                          </CardContent>
                        </Card>
                      </motion.div>
                    </Grid>
                  ))}
                </Grid>
              </motion.div>
            </Container>
          </Box>
          <CommonModal modalOpen={modalOpen} setModalOpen={setModalOpen} children={<NotAvailableModal mode={serviceModalText} />} />
          <Box
            sx={{
              background: "linear-gradient(180deg, #fffaf5 0%, #ffe8dc 100%)",
              py: { xs: 6, md: 10 },
              overflowX: "hidden !important",
              overflowY: "hidden !important",
            }}
          >
            <Container
              sx={{
                overflowX: "hidden !important",
                overflowY: "hidden !important",
              }}
              maxWidth="lg"
            >
              {/* Header */}
              <motion.div
                initial="hidden"
                whileInView="visible"
                variants={fadeUp}
              >
                <Typography
                  variant="h3"
                  align="center"
                  sx={{
                    fontWeight: "700 !important",
                    color: "#680000 !important",
                    fontFamily: "Playfair Display !important",
                    fontSize: {
                      xs: "16px !important",
                      sm: "24px !important",
                      md: "32px !important",
                    },
                    mb: 2,
                    textTransform: "uppercase",
                  }}
                >
                  About Rangooli Restaurant
                </Typography>
                <Typography
                  textAlign="center"
                  sx={{
                    mb: { xs: 2, md: 4 },
                    color: "#1A1A1A",
                    letterSpacing: 1,
                    fontSize: {
                      xs: "12px !important",
                      sm: "16px !important",
                      md: "18px !important",
                    },
                    fontWeight: "400 !important",
                  }}
                >
                  Where Flavor Meets Tradition — A Journey of Authentic Indian
                  Taste
                </Typography>
              </motion.div>

              {/* Image + Text Section */}
              <Grid
                container
                spacing={6}
                alignItems="center"
                justifyContent="center"
                sx={{
                  maxWidth: "1480px",
                  margin: "0 auto",
                  mb: 10,
                  px: 2, // ⭐ FIX: prevents right-side cutting on mobile
                  overflowX: "hidden !important",
                  overflowY: "hidden !important",
                }}
              >
                {/* IMAGE SECTION */}
                <Grid item xs={12} md={6} sx={{ width: "100%", pl: { xs: "0px !important" } }}>
                  <motion.div
                    initial="hidden"
                    whileInView="visible"
                    variants={fadeUp}
                    style={{ position: "relative", width: "100%" }}
                  >
                    {/* Decorative Background Circle */}
                    <Box
                      sx={{
                        p: { xs: 0 },
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "60vw", sm: "200px", md: "400px" },
                        height: { xs: "60vw", sm: "200px", md: "400px" },
                        maxWidth: "250px",
                        maxHeight: "250px",
                        borderRadius: "50%",
                        background:
                          "radial-gradient(circle, rgba(255,214,182,0.3) 0%, rgba(255,255,255,0) 70%)",
                        zIndex: 1,
                      }}
                    />

                    {/* Main Image */}
                    <Box
                      component="img"
                      src={about_img}
                      alt="Restaurant Interior"
                      sx={{
                        width: { xs: "87%", sm: "87%", md: "100%" },
                        maxWidth: "100%", // ⭐ Prevent overflow
                        height: { xs: "240px", sm: "300px", md: "420px" },
                        objectFit: "cover",
                        borderRadius: "20px",
                        position: "relative",
                        zIndex: 2,
                        boxShadow: "0 20px 50px rgba(0,0,0,0.2)",
                        transition: "transform 0.6s ease !important",
                        "&:hover": {
                          transform: "scale(1.03) !important",
                        },
                      }}
                    />
                  </motion.div>
                </Grid>

                {/* TEXT SECTION */}
                <Grid item xs={12} md={6} sx={{ width: "100%", pl: { xs: "0px !important", md: "48px !important" } }}>
                  <motion.div
                    initial="hidden"
                    whileInView="visible"
                    variants={fadeUp}
                  >
                    <Typography
                      sx={{
                        width: { xs: "87%", sm: "87%", md: "100%" },
                        color: "#1a1a1a !important",
                        fontFamily: "Inter, sans-serif !important",
                        fontSize: {
                          xs: "12px !important",
                          sm: "16px !important",
                          md: "18px !important",
                        },
                        lineHeight: "1.9 !important",
                        fontWeight: "400 !important",
                      }}
                    >
                      At Rangooli Restaurant, every dish is a story — a tale of
                      vibrant spices, authentic recipes, and the warmth of
                      Indian hospitality. Our chefs bring generations of
                      culinary expertise to your table, creating a fine balance
                      between traditional flavors and modern elegance.
                      <br />
                      <br />
                      Established in 2005, Rangooli began as a small family
                      eatery and has now evolved into a cultural dining
                      destination. We believe that food is an art — and we serve
                      every plate with passion, love, and creativity.
                    </Typography>
                  </motion.div>
                </Grid>
              </Grid>

              {/* Signature Dishes Title */}
              <motion.div
                initial="hidden"
                whileInView="visible"
                variants={fadeUp}
              >
                <Typography
                  textAlign="center"
                  sx={{
                    fontFamily: "Playfair Display !important",
                    fontWeight: "700 !important",
                    color: "#680000 !important",
                    fontSize: {
                      xs: "18px !important",
                      sm: "24px !important",
                      md: "30px !important",
                    },
                    mb: 4,
                    textTransform: "uppercase",
                    letterSpacing: 1,
                  }}
                >
                  Our Signature Dishes
                </Typography>
              </motion.div>

              {/* Signature Dish Carousel */}
              <motion.div
                initial="hidden"
                whileInView="visible"
                variants={fadeUp}
              >
                <Box
                  sx={{
                    width: "100%",
                    pt: 0,
                    pb: 4,
                    maxWidth: "1480px",
                    margin: "0 auto",
                  }}
                >
                  <Swiper
                    modules={[Autoplay]} // Only Autoplay module
                    // navigation={true}
                    spaceBetween={16}
                    slidesPerView={"auto"}
                    autoplay={{
                      delay: 500, // Time between transitions (ms)
                      disableOnInteraction: false, // Continue after user interaction
                      pauseOnMouseEnter: true, // Pause when hovering
                    }}
                    loop={true} // Enable infinite loop
                    speed={800} // Transition speed (ms)
                    style={{ paddingBottom: "10px" }}
                  >
                    {dishImages.map((img, i) => (
                      <SwiperSlide
                        key={i}
                        style={{
                          width: "300px",
                          height: "220px",
                          borderRadius: "12px",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={img}
                          alt="Signature Dish"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Box>
              </motion.div>

              {/* Final Section */}
              <motion.div
                initial="hidden"
                whileInView="visible"
                variants={fadeUp}
              >
                <Box
                  sx={{
                    textAlign: "center",
                    maxWidth: "800px",
                    mx: "auto",
                    px: 2,
                  }}
                >
                  <Typography
                    sx={{
                      color: "#680000 !important",
                      fontFamily: "Playfair Display !important",
                      fontSize: {
                        xs: "22px !important",
                        md: "30px !important",
                      },
                      mb: 3,
                      fontWeight: "700 !important",
                    }}
                  >
                    “We don’t just serve food — we serve memories.”
                  </Typography>
                  <Typography
                    sx={{
                      color: "#1a1a1a !important",
                      fontFamily: "Inter, sans-serif !important",
                      fontSize: {
                        xs: "12px !important",
                        sm: "16px !important",
                        md: "18px !important",
                      },
                      lineHeight: "1.9 !important",
                      fontWeight: "400 !important",
                    }}
                  >
                    Whether it’s your first visit or your fiftieth, Rangooli
                    welcomes you like family. Join us in celebrating India’s
                    timeless flavors, vibrant colors, and the soul of true
                    hospitality.
                  </Typography>
                </Box>
              </motion.div>
            </Container>
          </Box>

          {/* Testimonials */}
          <Box sx={{ mb: { xs: 5, md: 8 }, backgroundColor: "#FFFFFF" }}>
            <ScrollAnimation animation="fadeUp" delay={100}>
              <TestimonialSlider restaurant={restaurant} />
            </ScrollAnimation>
          </Box>
        </Box>

        {/* View Details Modal */}
        <ViewDetailsModal
          open={viewDetailsOpen}
          onClose={() => setViewDetailsOpen(false)}
          item={selectedItem}
        />

        {/* Outlet Selection Modal */}
        <OutletSelectionModal
          open={showOutletSelectionModal}
          onClose={closeOutletSelection}
          onOutletSelect={handleOutletSelection}
        />

        <Footer2 />




        <Tooltip
          title="Contact Via WhatsApp"
          placement="left"
          arrow
          TransitionProps={{ timeout: 300 }}
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: '1.1rem',
                fontWeight: 500,
                padding: '10px 16px',
                backgroundColor: '#25D366', // WhatsApp brand color
                '& .MuiTooltip-arrow': {
                  color: '#25D366',
                }
              }
            }
          }}
        >
          <Button
            variant="contained"
            onClick={handleWhatsAppClick} // Update this function
            // href={socialLinks.whatsapp}
            sx={{
              position: 'fixed',
              right: 24,
              bottom: 94,
              zIndex: 1000,
              borderRadius: '50%',
              width: 64,
              height: 64,
              minWidth: 0,
              padding: 0,
              backgroundColor: '#25D366',
              color: 'white',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              '&:hover': {
                backgroundColor: '#128C7E', // Darker WhatsApp color on hover
                transform: 'scale(1.1)',
                boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
                animation: 'pulse 1.5s infinite',
              },
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '@keyframes pulse': {
                '0%': {
                  boxShadow: '0 0 0 0 rgba(37, 211, 102, 0.7)',
                },
                '70%': {
                  boxShadow: '0 0 0 10px rgba(37, 211, 102, 0)',
                },
                '100%': {
                  boxShadow: '0 0 0 0 rgba(37, 211, 102, 0)',
                },
              }
            }}
          >
            <WhatsApp
              sx={{
                width: 32,
                height: 32,
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'rotate(15deg) scale(1.1)',
                }
              }}
            />
          </Button>
        </Tooltip>

        <Tooltip
          title="Download Menu PDF"
          placement="left"
          arrow
          TransitionProps={{ timeout: 300 }}
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: '1.1rem', // Increase font size
                fontWeight: 500,
                padding: '10px 16px', // Adjust padding for larger text
                backgroundColor: '#680000', // Match button color
                '& .MuiTooltip-arrow': {
                  color: '#680000', // Make arrow match tooltip color
                }
              }
            }
          }}
        >
          <Button
            variant="contained"
            onClick={handleMenuDownload}
            sx={{
              position: 'fixed',
              right: 24,
              bottom: 24,
              zIndex: 1000,
              borderRadius: '50%',
              width: 64,
              height: 64,
              minWidth: 0,
              padding: 0,
              backgroundColor: '#680000',
              color: 'white',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              '&:hover': {
                backgroundColor: '#680000',
                transform: 'scale(1.1)',
                boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
                animation: 'pulse 1.5s infinite',
              },
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              overflow: 'hidden', // Keep this for the icon container
              '@keyframes pulse': {
                '0%': {
                  boxShadow: '0 0 0 0 rgba(25, 118, 210, 0.7)',
                },
                '70%': {
                  boxShadow: '0 0 0 10px rgba(25, 118, 210, 0)',
                },
                '100%': {
                  boxShadow: '0 0 0 0 rgba(25, 118, 210, 0)',
                },
              }
            }}
          >
            {/* Replace this with your menu.png */}
            <Box
              component="img"
              src={menu} // Update this path
              alt="Menu icon"
              sx={{
                width: 32,
                height: 32,
                filter: 'brightness(0) invert(1)', // Makes the icon white
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'rotate(15deg) scale(1.1)',
                }
              }}
            />
          </Button>
        </Tooltip>

      <CommonModal modalOpen={adminNavigationModalOpen} setModalOpen={setAdminNavigationModalOpen} children={<AdminConfirmComponent onConfirm={handleConfirm} onCancel={handleCancel}/>}/> 
      </Box>
    </>
  );
};

const AdminConfirmComponent = ({ onConfirm, onCancel }) => {
  return (
    <>
      <Typography 
        variant="h4" 
        sx={{
          textAlign: 'center',
          color: '#1A1A1A',
          fontWeight: 600,
          mb: 3,
          
        }}
      >
        You are going to Log out from Admin Site. Are You Sure?
      </Typography>
      
      <Box 
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          gap: 2,
          mt: 2
        }}
      >
        <Button 
          variant="outlined"
          onClick={onCancel}
          sx={{
            borderColor: '#680000',
            color: '#680000',
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
            py: 1,
            '&:hover': {
              backgroundColor: 'rgba(104, 0, 0, 0.04)',
              borderColor: '#8b0000',
              transform: 'scale(1.02)',
            },
            transition: 'all 0.3s ease'
          }}
        >
          Cancel
        </Button>
        
        <Button 
          variant="contained"
          onClick={onConfirm}
          sx={{
            backgroundColor: '#680000',
            color: '#ffffff',
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
            py: 1,
            '&:hover': {
              backgroundColor: '#8b0000',
              transform: 'scale(1.02)',
              boxShadow: '0 4px 12px rgba(104, 0, 0, 0.3)',
            },
            transition: 'all 0.3s ease'
          }}
        >
          Confirm
        </Button>
      </Box>
    </>
  );
};


const NotAvailableModal = ({ mode }) => {
  return (
    <>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, textAlign: 'center' }}>
        <Warning sx={{ fontSize: '40px !important', color: "#680000", }} />

        <Typography sx={{
          // fontFamily: "playfair Display !important",
          color: "#680000",
          textTransform: "uppercase",
          letterSpacing: 1,
          fontWeight: "600 !important",
          fontSize: {
            xs: "10px !important",
            sm: "12px !important",
            md: "16px !important",
          },
          width: '45%',
          mb: { xs: 0.5, md: 1 },
        }}>
          Sorry , {mode} is not Available in the Current Outlet Please Select Another Outlet
        </Typography>

      </Box>
    </>
  )
}

export default HomePage;
